import Service from './Service';

export default class SlaService extends Service{
    constructor() {
        super();
        this.baseURL = 'sla';
    }

}